var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "profile" } },
    [
      _c("div", { staticClass: "part-1" }, [
        _c("div", { staticClass: "container" }, [
          _c("h1", [_vm._v(_vm._s(_vm._f("translate")("PROFILE_MAIN_TITLE")))]),
          _vm._v(" "),
          _c("h2", [
            _vm._v(_vm._s(_vm._f("translate")("PROFILE_MAIN_SUBTITLE"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.allProgress, function (areaProgress, areaId) {
        return _c(
          "div",
          {
            key: areaId,
            staticClass: "area-specific-part",
            class: "part-" + _vm.area(areaId).css_class_name,
          },
          [
            _c(
              "div",
              { staticClass: "container" },
              [
                _c("div", { staticClass: "row area-description-row" }, [
                  _c("div", { staticClass: "bg-img img-responsive" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-5 col-sm-offset-7 area-description-col",
                    },
                    [
                      _c("h2", [_vm._v(_vm._s(_vm.area(areaId).name))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.area(areaId).description))]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn primary-btn",
                          attrs: {
                            disabled:
                              areaId == _vm.currentAreaId ? false : true,
                          },
                          on: { click: _vm.continueButton },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm._f("translate")("PROFILE_CONTINUE")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      areaId != _vm.currentAreaId
                        ? _c("div", { staticClass: "area-finished-text" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._f("translate")("PROFILE_AREA_FINISHED")
                                ) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("user-progress", {
                  attrs: {
                    stats: areaProgress,
                    showProgressbar: true,
                    progressbarValue: _vm.areaLevelProgress(areaId),
                    showLeaderboardLink:
                      areaId == _vm.currentAreaId ? true : false,
                  },
                }),
              ],
              1
            ),
          ]
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "achievements-part-1" }, [
        _c("div", { staticClass: "container" }, [
          _c("h1", [
            _vm._v(_vm._s(_vm._f("translate")("ACHIEVEMENTS_MAIN_TITLE"))),
          ]),
          _vm._v(" "),
          _c("h3", [
            _vm._v(_vm._s(_vm.currentAreaDetails.achievements_main_subtitle)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row achievements-title" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("h2", [
                _vm._v(
                  _vm._s(_vm._f("translate")("ACHIEVEMENTS_UNLOCKED_TITLE"))
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row achievements-row" }, [
            _vm.areThereAnyUnlocked
              ? _c(
                  "ul",
                  { staticClass: "list-group achievements-list" },
                  _vm._l(
                    _vm.currentUnlockedAchievements,
                    function (achievement) {
                      return _c(
                        "div",
                        {
                          key: achievement.id,
                          staticClass: "col-xs-12 col-sm-6",
                        },
                        [
                          _c("list-item", {
                            attrs: {
                              "img-path": achievement.image_path,
                              title: achievement.name,
                              desc: achievement.description,
                              tag: achievement.category_name,
                              "data-key": "unlockedAchievements",
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              : _c("p", { staticClass: "empty-achievements" }, [
                  _vm._v(_vm._s(_vm._f("translate")("NO_ACHIEVEMENTS_YET"))),
                ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "achievements-part-2" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row achievements-title" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("h2", [
                _vm._v(
                  _vm._s(_vm._f("translate")("ACHIEVEMENTS_LOCKED_TITLE"))
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row achievements-row" }, [
            _vm.areThereAnyLocked
              ? _c(
                  "ul",
                  { staticClass: "list-group achievements-list" },
                  _vm._l(_vm.currentLockedAchievements, function (achievement) {
                    return _c(
                      "div",
                      {
                        key: achievement.id,
                        staticClass: "col-xs-12 col-sm-6",
                      },
                      [
                        _c("list-item", {
                          attrs: {
                            "img-path": achievement.image_path,
                            title: achievement.name,
                            desc: achievement.description,
                            tag: achievement.category_name,
                            "data-key": "lockedAchievements",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _c("p", { staticClass: "empty-achievements" }, [
                  _vm._v(
                    _vm._s(_vm._f("translate")("ALL_ACHIEVEMENTS_UNLOCKED"))
                  ),
                ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      !_vm.ssoEnabled
        ? _c("div", { staticClass: "part-2" }, [
            _c("div", { staticClass: "container" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm._f("translate")("PROFILE_EDIT_MAIN_TITLE"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-md-6 col-md-offset-3" },
                  [_c("change-password")],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }